/**
 * Separator value for concat 'DEFAULT_ADDRESS_VALUE'
 * This value is separated for validation when is needed remove it from catalog response
 */
export const SEPARATOR_DEFAULT_ADDRESS_VALUE = ' - ';

/**
 * Value that we should send into the point of delivery payload when some of the values are empty.
 * This with the purpose to avoid empty values at the creation moment of the pod
 * and finish the save process without errors.
 */
export const DEFAULT_ADDRESS_VALUE = ` ASKLCTN`;

/**
 * Value to be sent in the delivery point payload when the city description is empty.
 * This with the purpose to avoid empty values at the creation moment of the pod
 * and finish the save process without errors.
 */
export const DEFAULT_CITY_VALUE = `CITY`;

/**
 * Value to be sent in the delivery point payload when the domicile number is empty.
 * This with the purpose to avoid empty values at the creation moment of the pod
 * and finish the save process without errors.
 */
export const DEFAULT_DOMICILE_NUM_VALUE = `NUM`;

/**
 * Value to be sent in the delivery point payload when the postal code is empty.
 * This with the purpose to avoid empty values at the creation moment of the pod
 * and finish the save process without errors.
 */
export const DEFAULT_POSTAL_CODE_VALUE = `ZIP`;

/**
 * Value that determines the maximum length of the street name
 * when the address NOT include ASKLCTN
 */
export const MAX_LENGTH_ADDRESS_NO_ASKLCTN = 36;

/**
 * Value that determines the maximum length of the street name
 * when the address include ASKLCTN
 */
export const MAX_LENGTH_ADDRESS = 28;

/**
 * Default value to POD when the address type its an intersection
 */
export const INTERSECTION_DEFAULT_VALUE = 'INT';
